export const environment = {
  production: false,
  /** Shown as a badge in the admin top bar; empty hides the badge. */
  label: 'DEV',
  /**
   * Use same-origin `/api/...` so `ng serve` can forward via `proxy.conf.json`
   * (see WorkNest.BackEnd.HR `Api/Properties/launchSettings.json` → https profile: port 6006).
   * Override with a full URL if you call the API directly (ensure CORS on the API).
   */
  apiBaseUrl: 'https://dev-api.worknest.cloud',
  /** Local single API host: WebSockets are fine. Set true if you proxy to a scaled-out dev API. */
  signalrSkipWebSockets: false,
  /** Empty = use `apiBaseUrl`. Override when WorkFlow runs on another origin than HR. */
  workflowApiBaseUrl: '',
  /** MapTiler (or compatible) key for Leaflet raster tiles in map pickers. */
  mapTilesApiKey: 'F7in0tZTpltYwcVnQKJY',
  /** e.g. `https://n8n.example.com` — leave empty to hide the studio link locally. */
  n8nEditorUrl: '',
};
